import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../../shared/components/layout/AppLayout';

const RecentPage: React.FC = () => {
  const { orgId } = useParams<{ orgId: string }>();

  return (
    <AppLayout currentApp="Home" orgId={orgId} showNotifications={true} showDiscover={true}>
      <div className="p-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Recent</h1>
          
          <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
            <div className="text-gray-500 text-lg">
              This is to be done
            </div>
            <p className="text-gray-400 mt-2">
              Recent page content will be implemented here
            </p>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default RecentPage;
